var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "case-time-v2", attrs: { "data-lang": _vm.$i18n.locale } },
    [
      _vm.context.Service.enabled
        ? [
            _vm.ShowButton
              ? _c("CaseTimeButton", {
                  attrs: { "user-case-item": _vm.userCaseItem },
                  on: { click: _vm.onClickRecordButton },
                })
              : _vm._e(),
            _c("CaseTimeDialog", {
              ref: "caseTimeDialogRef",
              on: { update: _vm.onUpdateCaseTime },
            }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }